// context/articlesConfig.js
import React, { createContext, useContext } from 'react';

// Articles data — add one object per week to publish a new article
const articlesData = [

];

const ArticlesContext = createContext();

export const ArticlesProvider = ({ children }) => {
    const value = {
        articles: articlesData,
        getArticleById: (id) => articlesData.find(article => article.id === id),
        getNextArticle: (id) => {
            const currentIndex = articlesData.findIndex(article => article.id === id);
            const nextIndex = (currentIndex + 1) % articlesData.length;
            return articlesData[nextIndex];
        },
        getPreviousArticle: (id) => {
            const currentIndex = articlesData.findIndex(article => article.id === id);
            const prevIndex = currentIndex === 0 ? articlesData.length - 1 : currentIndex - 1;
            return articlesData[prevIndex];
        }
    };

    return (
        <ArticlesContext.Provider value={value}>
            {children}
        </ArticlesContext.Provider>
    );
};

export const useArticles = () => {
    const context = useContext(ArticlesContext);
    if (context === undefined) {
        throw new Error('useArticles must be used within an ArticlesProvider');
    }
    return context;
};

export const articles = articlesData;
